export function isNotificationsQuestQueryKey(queryKey) {
    if (!Array.isArray(queryKey) || queryKey[0] !== 'quests' || typeof queryKey[1] !== 'string') {
        return false
    }

    try {
        const filter = JSON.parse(queryKey[1])
        return filter?.notifications === true
    } catch (_) {
        return false
    }
}
